












































































































































import { Component, Prop, Vue } from 'vue-property-decorator';

import _keyBy from 'lodash.keyby';
import _map from 'lodash.map';

import { generateTagId } from '@/utils/makeId';
import { toSeconds, toDateTime } from '@/utils/timeFormat';

import TrackModal from '@/components/TrackModal.vue';
import TrackSelectModal from '@/components/TrackSelectModal.vue';

@Component
export default class TagModal extends Vue {
  @Prop() readonly mode!: string;
  @Prop() readonly video!: any;
  @Prop() readonly tag!: any;
  @Prop() readonly tags!: any[];
  @Prop() readonly tracks!: any[];
  @Prop() readonly track: any | null | undefined;
  @Prop() readonly duration!: number;
  @Prop() readonly time!: number;

  default_tag_duration: number = this.video.settings.default_tag_duration;
  max_time: Date = toDateTime(this.duration);
  tracks_index: any = _keyBy(this.tracks, 'id');
  tag_instance: any = {
    id: '',
    name: '',
    start: new Date(Date.UTC(0, 0, 0, 0, 0, 0)),
    end: new Date(Date.UTC(0, 0, 0, 0, 0, 0)),
    note: '',
    track: [],
  };

  active: any = {
    tracks: [],
  };

  mounted() {
    if (this.mode === 'edit') {
      this.tag_instance = {
        ...this.tag,
        start: toDateTime(this.tag.start),
        end: toDateTime(
          this.tag.end || this.tag.start + this.default_tag_duration
        ),
      };

      // this.active.tracks = this.tracks.filter((track: any) => {
      //   return this.tag.track.indexOf(track.id) > -1;
      // });
      this.active.tracks = this.tag.track.map(
        (track_id: any) => this.tracks_index[track_id]
      );
    } else {
      const id = generateTagId(this.tags);
      this.tag_instance.id = `tag_${id}`;
      this.tag_instance.start = toDateTime(this.time);

      let end_seconds = this.time + this.default_tag_duration;
      if (end_seconds > this.duration) {
        let end_second = this.duration;
      }

      this.tag_instance.end = toDateTime(end_seconds);

      if (this.track && this.track.id !== 'trackless') {
        this.tag_instance.track = [this.track.id];
        // this.active.tracks = this.tracks.filter((track: any) => {
        //   return track.id === this.track.id;
        // });
        this.active.tracks = [this.tracks_index[this.track.id]];
      }
    }
  }

  openTrackModal(mode: string) {
    this.$buefy.modal.open({
      parent: this,
      component: TrackModal,
      hasModalCard: true,
      canCancel: ['escape', 'outside'],
      props: {
        mode,
        video: this.video,
        tracks: this.tracks,
        track: {},
        tags: this.tags,
        duration: this.duration,
      },
      events: {
        create: (track: any) => {
          this.active.tracks.push(track);
        },
      },
    });
  }

  openTrackSelectModal() {
    this.$buefy.modal.open({
      parent: this,
      component: TrackSelectModal,
      hasModalCard: true,
      canCancel: ['escape', 'outside'],
      props: {
        tracks: this.tracks.slice(1),
        active: this.active,
      },
      events: {
        done: (data: any) => {
          this.active.tracks = data;
        },
      },
    });
  }

  remove() {
    this.$buefy.dialog.confirm({
      title: 'Deleting Tag',
      message:
        'Are you sure you want to <b>delete</b> this tag? This action cannot be undone.',
      confirmText: 'Delete Tag',
      type: 'is-danger',
      hasIcon: true,
      onConfirm: () => {
        const index = this.tags.indexOf(this.tag);

        if (index > -1) {
          this.tags.splice(index, 1);
        }

        this.$buefy.toast.open('Tag deleted.');
        this.$emit('remove', this.tag);
        this.$emit('close');
      },
    });
  }

  validate() {
    if (
      this.tag_instance.end <= this.tag_instance.start ||
      this.tag_instance.start >= this.tag_instance.end
    ) {
      this.$buefy.toast.open({
        message: 'End time must be after start time.',
        type: 'is-warning',
      });
      return;
    }

    if (
      this.tag_instance.start > this.max_time ||
      this.tag_instance.end > this.max_time
    ) {
      this.$buefy.toast.open({
        message: 'Start/end time must be within the video duration.',
        type: 'is-warning',
      });
      return;
    }

    return true;
  }

  format() {
    const start_seconds = toSeconds(
      `${this.tag_instance.start.getUTCHours()}:${this.tag_instance.start.getUTCMinutes()}:${this.tag_instance.start.getUTCSeconds()}`
    );

    const end_seconds = toSeconds(
      `${this.tag_instance.end.getUTCHours()}:${this.tag_instance.end.getUTCMinutes()}:${this.tag_instance.end.getUTCSeconds()}`
    );

    return {
      start_seconds,
      end_seconds,
    };
  }

  create() {
    if (!this.validate()) {
      return;
    }

    const { start_seconds, end_seconds } = this.format();

    this.tag_instance.start = start_seconds;
    this.tag_instance.end = end_seconds;
    this.tag_instance.track = _map(this.active.tracks, 'id');

    this.tags.push(this.tag_instance);

    this.$emit('create', this.tag_instance);
    this.$emit('close');
  }

  duplicate() {
    this.$buefy.dialog.confirm({
      title: 'Duplicating Tag',
      message:
        'Are you sure you want to <b>duplicate</b> this tag to the selected tracks?',
      confirmText: 'Duplicate Tag',
      type: 'is-primary',
      hasIcon: true,
      onConfirm: () => {
        if (!this.validate()) {
          return;
        }

        const id = generateTagId(this.tags);
        this.tag_instance.id = `tag_${id}`;

        this.$buefy.toast.open('Tag duplicated.');
        this.create();
      },
    });
  }

  save() {
    if (!this.validate()) {
      return;
    }

    const { start_seconds, end_seconds } = this.format();

    this.tag.start = start_seconds;
    this.tag.end = end_seconds;
    this.tag.track = _map(this.active.tracks, 'id');

    if (this.tag_instance.name !== this.tag.name) {
      this.tag.name = this.tag_instance.name;
    }

    if (this.tag_instance.note !== this.tag.note) {
      this.tag.note = this.tag_instance.note;
    }

    this.$emit('save', this.tag);
    this.$emit('close');
  }
}
